<div class="font-weight-bold" [class.align-items-end]="size !== 'big'">
  <div class="d-flex align-items-center justify-content-end">
    <span *ngIf="timeConsumed; else consumed0">{{ timeConsumed | digitFormat }}
      <ng-container *ngIf="overtime">
        + {{ overtime | digitFormat }}
      </ng-container>
    </span>

    <ng-template #consumed0>{{ 0 | digitFormat }}</ng-template>

    <span>/</span>

    <span *ngIf="timeAvailable; else available0">{{ timeAvailable | digitFormat }}</span>

    <ng-template #available0>{{ 0 | digitFormat }}</ng-template>

    <i *ngIf="type" class="fa fa-{{type === 'time' ? 'clock': 'layer-group'}} ml-1"></i>
  </div>
  <div class="d-flex justify-content-end">
    <div class="progress progress-sm"
         [style.width]="size === 'big' ? '100%' : '60px'">
      <div class="progress-bar bg-primary" role="progressbar"
           [style.width]="(timeConsumed / timeAvailable) * 100 + '%'"></div>
    </div>
  </div>
</div>
